import classNames from 'classnames';
import React from 'react';

interface IProps {
  readonly children: React.ReactNode;
  readonly className: string;
  readonly selectedIndex: number;
  readonly index: number;
}

export const NavigateItem = (props: IProps) => {
  const isActive = props.selectedIndex === props.index;
  const className = classNames(props.className, isActive ? 'active' : '');

  return <div className={className}>{props.children}</div>;
};
